Apt.fn.make('report', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;

		scope.conf = Object.assign({
			namespace: LS.util.uid()
		}, options);

		$.events.on('$report', 'click', (e, el) => {
			if (! options.id) {
				options.id = $(el).closest(options.parent)
					.data('id');
			}

			scope.show(options);
		}, {
			break: true,
			cancel: true,
			delegate: options.delegate,
			namespace: scope.conf.namespace
		});

		return scope;
	},

	/**
	 * Display report modal
	 *
	 * @param {Object} options
	 */
	show(options) {
		const scope = this;

		LS.modal.open({
			url: '/report/' + options.target,
			success: () => {
				scope.$private.bind(options.target, options.id);
			},
			onHide: () => {
				$.events.reset(scope.conf + 'form');
			}
		});
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		$.events.reset(this.conf.namespace);
	}
}, {
	/**
	 * Bind report submit event
	 *
	 * @param {String} target
	 * @param {String} id
	 */
	bind(target, id) {
		const namespace = this.$public.conf + 'form';
		const email = LS.user.get('email');

		LS.api.bind('$reportForm', `${target}/${id}/report`, {
			method: 'put',
			validate: true,
			namespace: namespace,
			success: () => {
				LS.modal.close();
			}
		});

		if (email) {
			$$('reportEmail').val(email);
		}

		$$('reportDescription').resize(namespace);
	}
});